import { buildProps } from '@element-plus/utils'
import type { ExtractPropTypes } from 'vue'
import type SkeletonGrid from './skeleton-grid.vue'

export const skeletonGridProps = buildProps({
  /**
   * @description Number of grid rows
   */
  rows: {
    type: Number,
    default: 1,
    validator: (val) => Number.parseInt(val, 10) > 0,
  },
  /**
   * @description Number of grid cols.
   */
  cols: {
    type: Number,
    default: 2,
    validator: (val) => Number.parseInt(val, 10) > 0,
  },
  /**
   * @description Gutter of gird item.
   */
  gutter: {
    type: [Number, Array],
    default: 16,
    validator: (val) => {
      if (Array.isArray(val)) {
        return (
          (typeof val[0] === 'undefined' || Number.parseInt(val[0], 10) >= 0) &&
          (typeof val[1] === 'undefined' || Number.parseInt(val[1], 10) >= 0)
        )
      }
      return Number.parseInt(val, 10) >= 0
    },
  },
  /**
   * @description Custom height of grid item
   */
  itemHeight: {
    type: Number,
    default: 16,
    validator: (val) => Number.parseInt(val, 10) > 0,
  },
} as const)
export type SkeletonGridProps = ExtractPropTypes<typeof skeletonGridProps>

export type SkeletonGridInstance = InstanceType<typeof SkeletonGrid>
